import { render } from "./insure-report-detail.vue?vue&type=template&id=6878e906&scoped=true&ts=true"
import script from "./insure-report-detail.vue?vue&type=script&lang=ts"
export * from "./insure-report-detail.vue?vue&type=script&lang=ts"

import "./insure-report-detail.vue?vue&type=style&index=0&id=6878e906&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6878e906"]])

export default __exports__